import React, { Component } from 'react'

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { 
            hasError: false 
        }
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true })

        this.props.openModal('error', null, { 
            message: "Well this is awkward. Looks like something's busted.",
            shouldLogOut: true
        })
        //logErrorToMyService(error, info);
    }

    render() {
        const {
            hasError
        } = this.state

        const {
            children
        } = this.props

        if (hasError) {
            return <div className="error-background" />
        }
        return children
    }
}



// WEBPACK FOOTER //
// ./src/components/error-boundary/error-boundary.jsx